import { jsx as _jsx } from "react/jsx-runtime";
import { Stack } from '@mui/material';
import { trueIsBad, WrapLinkVOB } from '../../../factories/DataGrid';
import { StripedDataGrid } from '../../../factories/DataGrid/styles/striped';
import { duration, sinceNow } from '../../../NetworkSystem/cellFormatters/valueFormatters';
const debug = process.env.REACT_APP_DEBUG && false;
const common = {
    resizable: false,
    disableColumnMenu: true,
};
const columns = [
    {
        field: 'name',
        headerName: 'Name',
        ...common,
        width: 200,
        renderCell: (p) => WrapLinkVOB(p, 'sk'),
    },
    {
        field: 'Network',
        headerName: 'Network',
        ...common,
        width: 180,
    },
    {
        field: 'isAWOL',
        headerName: 'AWOL?',
        ...common,
        width: 80,
        renderCell: trueIsBad,
    },
    {
        field: 'lastSeen',
        headerName: 'Last Seen',
        ...common,
        width: 200,
        valueFormatter: sinceNow,
    },
    {
        field: '_permittedAWOL',
        headerName: 'Max. AWOL',
        ...common,
        width: 150,
        valueFormatter: duration,
    },
    {
        field: 'wideawakePersist',
        headerName: 'Last Saved',
        ...common,
        width: 200,
        valueFormatter: sinceNow,
    },
];
export const NetworkDataGrid = ({ loading, networks }) => {
    const dataGridProps = {
        columns: columns,
        loading,
        rows: networks,
        getRowClassName: (params) => (params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'),
        density: 'compact',
        hideFooter: networks.length <= 10,
        hideFooterPagination: networks.length <= 10,
        initialState: { sorting: { sortModel: [{ field: 'lastSeen', sort: 'asc' }] }, pagination: { paginationModel: { pageSize: 10 } } },
    };
    debug && console.log('Network DataGrid produced props ', dataGridProps);
    return (_jsx(Stack, { sx: { overflowX: 'auto' }, children: _jsx(StripedDataGrid, { style: { fontSize: 'inherit' }, ...dataGridProps }) }));
};
